<ng-container *ngIf="textInputModel">
  <form class="row row-cols-lg-auto gy-2 gx-3 align-items-center">
    <ng-container *ngIf="editing;else static">
      <div class="col-auto">
        <label class="col-form-label" [attr.for]="textInputModel.id">{{ textInputModel.label }}:</label>
      </div>
      <div class="col-auto">
        <div *ngIf="canEdit" class="input-group input-group-sm" [ngClass.was-validated]="textInputModel.required">
          <input type="text" class="form-control" [(ngModel)]="textInputModel.dataValue" name="inputTxtCtrl" [attr.id]="textInputModel.id" [attr.required]="textInputModel.required" [attr.placeholder]="textInputModel.placeholder" [attr.maxlength]="textInputModel.stringLength">
          <button (click)="save()" class="btn btn-active" type="button" [attr.aria-label]="textInputModel.saveButtonAriaLabel" [attr.title]="textInputModel.saveButtonAriaLabel"><i class="fa fa-check" aria-hidden="true"></i></button>
          <button (click)="cancelEdit()" class="btn btn-danger" type="button" [attr.aria-label]="textInputModel.cancelButtonAriaLabel" [attr.title]="textInputModel.cancelButtonAriaLabel"><i class="fa fa-times" aria-hidden="true"></i></button>
          <div class="invalid-tooltip" *ngIf="textInputModel.required">
            {{ textInputModel.requiredMessage }}
          </div>
        </div>
      </div>
    </ng-container>
      <ng-template #static>
        <div class="col-auto">
          <span class="col-form-label">{{ textInputModel.label }}:</span>
        </div>
        <div class="col-auto">
          <div class="d-inline-flex align-items-center">
            <div class="me-2">{{ textInputModel.dataValue }}</div>
            <button *ngIf="canEdit" (click)="toggleEdit()" id="editBtn" class="btn btn-sm btn-outline-success" type="button" [attr.aria-label]="!!textInputModel.dataValue ? 'Edit' : 'Add'" [attr.title]="!!textInputModel.dataValue ? 'Edit' : 'Add'"><i class="pi pi-pencil" aria-hidden="true"></i></button>
          </div>
        </div>
      </ng-template>
  </form>
</ng-container>
